module.exports = __webpack_public_path__ + "static/media/desayunosbrunch.aacf3d6e.svg";